export function formatStatus(status: string): string {
  const map: Record<string, string> = {
    APPLIED: 'Applied',
    UNDER_REVIEW: 'Review',
    SHORTLISTED: 'Shortlisted',
    ASSESSMENT_SENT: 'Assessment',
    INTERVIEW_SCHEDULED: 'Interview',
    INTERVIEW_COMPLETED: 'Interviewed',
    OFFER_SENT: 'Offer',
    OFFER_ACCEPTED: 'Accepted',
    OFFER_REJECTED: 'Declined',
    SELECTED: 'Selected',
    REJECTED: 'Rejected',
    WITHDRAWN: 'Withdrawn',
  };
  return map[status] ?? status;
}

export function statusToColor(status: string): string {
  if (['SELECTED', 'OFFER_ACCEPTED', 'INTERVIEW_SCHEDULED'].includes(status)) return 'teal';
  if (['SHORTLISTED', 'OFFER_SENT', 'ASSESSMENT_SENT'].includes(status)) return 'info';
  if (['REJECTED', 'WITHDRAWN', 'OFFER_REJECTED'].includes(status)) return 'danger';
  return '';
}

export function formatRelativeTime(dateStr: string): string {
  const diff = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return `${Math.floor(diff / 604800)}w ago`;
}

export function isRecentJob(createdAt: string): boolean {
  return Date.now() - new Date(createdAt).getTime() < 3 * 24 * 60 * 60 * 1000;
}

export function formatLocationType(type: string): string {
  const map: Record<string, string> = { REMOTE: 'Remote', HYBRID: 'Hybrid', ONSITE: 'On-site' };
  return map[type] ?? type;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function formatSalary(job: {
  salaryMin: number | null;
  salaryMax: number | null;
  salaryCurrency: string;
}): string {
  const currency = job.salaryCurrency === 'INR' ? '₹' : '$';
  const fmt = (n: number) =>
    n >= 100000 ? `${(n / 100000).toFixed(0)}L` : `${(n / 1000).toFixed(0)}K`;
  if (job.salaryMin && job.salaryMax)
    return `${currency}${fmt(job.salaryMin)}–${fmt(job.salaryMax)}`;
  if (job.salaryMin) return `${currency}${fmt(job.salaryMin)}+`;
  if (job.salaryMax) return `Up to ${currency}${fmt(job.salaryMax)}`;
  return '';
}
